import {combineReducers} from 'redux';
import contacts from './contacts';

const contactsAppReducers = combineReducers({
    contacts: contacts.Reducer,
});

export default contactsAppReducers;


// WEBPACK FOOTER //
// ./src/store/actionreducers/trial_vip/index.js